var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompletedImg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "3rem",
    height: "3rem",
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.720703,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#102C97"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.7924 21.8939C42.6219 21.722 42.4192 21.5856 42.1958 21.4926C41.9724 21.3995 41.7327 21.3516 41.4907 21.3516C41.2487 21.3516 41.0091 21.3995 40.7857 21.4926C40.5622 21.5856 40.3595 21.722 40.189 21.8939L26.5307 35.5705L20.7924 29.8139C20.6154 29.6429 20.4065 29.5085 20.1776 29.4183C19.9487 29.3281 19.7043 29.2839 19.4583 29.2881C19.2123 29.2924 18.9696 29.345 18.7439 29.4431C18.5183 29.5412 18.3141 29.6827 18.1432 29.8597C17.9723 30.0367 17.8379 30.2455 17.7477 30.4744C17.6575 30.7033 17.6132 30.9478 17.6175 31.1938C17.6217 31.4398 17.6744 31.6825 17.7725 31.9082C17.8705 32.1338 18.0121 32.3379 18.189 32.5089L25.229 39.5489C25.3995 39.7207 25.6022 39.8571 25.8257 39.9502C26.0491 40.0432 26.2887 40.0912 26.5307 40.0912C26.7727 40.0912 27.0124 40.0432 27.2358 39.9502C27.4592 39.8571 27.6619 39.7207 27.8324 39.5489L42.7924 24.5889C42.9785 24.4172 43.127 24.2088 43.2286 23.9769C43.3301 23.745 43.3826 23.4945 43.3826 23.2414C43.3826 22.9882 43.3301 22.7377 43.2286 22.5058C43.127 22.2739 42.9785 22.0655 42.7924 21.8939Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedImg);
export default __webpack_public_path__ + "static/media/completedImg.a09980f5772c51ea98eb1a1d746822ed.svg";
export { ForwardRef as ReactComponent };